var x = Object.defineProperty;
var P = (t, e, o) => e in t ? x(t, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : t[e] = o;
var s = (t, e, o) => P(t, typeof e != "symbol" ? e + "" : e, o);
import { jsx as a } from "react/jsx-runtime";
import g from "react";
function m(t) {
  return typeof t == "string";
}
function p(t) {
  return Array.isArray(t);
}
function b(t) {
  return typeof t == "function";
}
function h(...t) {
  throw new Error(t.join(""));
}
const C = (t, ...e) => b(t) ? t(...e) : t;
function v() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
v();
function y(t = {}, e = {}, o = {}) {
  return Object.entries(e).reduce(
    (n, [r, i]) => {
      const c = o[i];
      return c !== null && typeof c < "u" && (n[r] = c), n;
    },
    { ...t }
  );
}
function A(t, e = []) {
  return (m(e) ? e.split(/,\s*|\s+/) : e).reduce(
    (n, r) => {
      const i = t[r] || h(`Cannot expose non-existent action method: ${r}`);
      return b(i) ? n[r] = i.bind(t) : h(`Cannot bind to non-function method: ${r}`), n;
    },
    {}
  );
}
function S(t, e) {
  const o = t.debug ?? e.debug, n = C(t.debugPrefix ?? e.debugPrefix, t), r = C(t.debugColor ?? e.debugColor, t);
  return o ? n ? (i, ...c) => console.log(
    `%c${n}%c${i}`,
    `color: ${r}`,
    "color:black",
    ...c
  ) : console.log.bind(console) : () => {
  };
}
const $ = (t) => p(t) ? t : [t], F = (t, e = {}) => {
  const o = e.defaultState || {}, n = e.context || g.createContext(o);
  return {
    Context: n,
    Provider: (d) => /* @__PURE__ */ a(
      t,
      {
        ...d,
        render: (u) => /* @__PURE__ */ a(n.Provider, { value: u, children: d.children })
      }
    ),
    Consumer: (d) => (u) => /* @__PURE__ */ a(n.Consumer, { children: (f) => /* @__PURE__ */ a(d, { ...f, ...u }) }),
    Children: ({ children: d }) => $(d).map(
      (u, f) => b(u) ? /* @__PURE__ */ a(n.Consumer, { children: u }, f) : u
    ),
    Use: () => g.useContext(n)
  };
};
class l extends g.Component {
  constructor(o) {
    super(o);
    s(this, "debug");
    s(this, "actions");
    const n = this.constructor, r = n.debug, i = n.debugPrefix, c = n.debugColor;
    this.debug = S(
      o,
      { debug: r, debugPrefix: i, debugColor: c }
    ), this.state = y(
      n.initialState,
      n.initialProps,
      o
    ), this.actions = this.initActions(n.actions);
  }
  initActions(o) {
    return A(this, o);
  }
  getContext() {
    return {
      ...this.props,
      // properties passed to the context
      ...this.state,
      // internal state
      ...this.actions
      // callable action functions mapped to methods
    };
  }
  getRenderProps() {
    return this.getContext();
  }
  render() {
    return this.props.render(
      this.getRenderProps()
    );
  }
}
s(l, "initialState", {}), s(l, "initialProps", {}), s(l, "actions", []), s(l, "debug", !1), s(l, "debugPrefix"), s(l, "debugColor");
export {
  l as Context,
  F as Generator
};
